module.exports = __webpack_public_path__ + "img/ematrica-logo.a75dfcee.svg";